module.exports = ".btn-import {\n  border-radius: .6rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/import-button/import-button.component.scss
// module id = ./src/app/components/import-button/import-button.component.scss
// module chunks = main